import { render, staticRenderFns } from "./ProfessionalForm.vue?vue&type=template&id=38ddbc22&scoped=true"
import script from "./ProfessionalForm.vue?vue&type=script&lang=js"
export * from "./ProfessionalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ddbc22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ddbc22')) {
      api.createRecord('38ddbc22', component.options)
    } else {
      api.reload('38ddbc22', component.options)
    }
    module.hot.accept("./ProfessionalForm.vue?vue&type=template&id=38ddbc22&scoped=true", function () {
      api.rerender('38ddbc22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/ProfessionalForm.vue"
export default component.exports